import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatPrice } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const { currency } = useCurrency();

  useEffect(() => {
    if (!loading && !user) navigate("/login", { replace: true });
  }, [loading, user, navigate]);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get("/orders/me");
        setOrders(data);
      } catch {}
    })();
  }, [user]);

  if (!user) return null;

  return (
    <main className="pt-24 md:pt-32 pb-24 px-6 md:px-12 lg:px-16" data-testid="account-page">
      <div className="grid md:grid-cols-12 gap-10">
        <aside className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Your Account</p>
          <h1 className="font-serif text-3xl mt-3">{user.name}</h1>
          <p className="text-sm text-[#7A7A7A]">{user.email}</p>
          <ul className="mt-8 space-y-2 text-[11px] uppercase tracking-nav">
            <li><Link to="/account" className="text-[#5C1A1B]" data-testid="acc-nav-orders">Orders</Link></li>
            <li><Link to="/wishlist" className="text-[#1A1A1A] hover:text-[#5C1A1B]" data-testid="acc-nav-wishlist">Wishlist</Link></li>
            {user.role === "admin" && (
              <li><Link to="/admin" className="text-[#1A1A1A] hover:text-[#5C1A1B]" data-testid="acc-nav-admin">Admin Panel</Link></li>
            )}
            <li><button onClick={async () => { await logout(); navigate("/"); }} className="text-[#1A1A1A] hover:text-[#5C1A1B]" data-testid="acc-nav-logout">Sign out</button></li>
          </ul>
        </aside>
        <section className="md:col-span-9">
          <h2 className="font-serif text-3xl mb-6">Recent orders</h2>
          {orders.length === 0 ? (
            <p className="text-[#7A7A7A] text-sm" data-testid="acc-no-orders">You haven’t placed any orders yet.</p>
          ) : (
            <ul className="divide-y divide-[#BCA37F]/25">
              {orders.map((o) => (
                <li key={o.order_id} className="py-5 flex items-center gap-6" data-testid={`acc-order-${o.order_id}`}>
                  <div className="flex-1">
                    <p className="font-mono-alt text-sm text-[#1A1A1A]">{o.order_id}</p>
                    <p className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">{o.created_at?.slice(0, 10)} · {o.items?.length} items · {o.status}</p>
                  </div>
                  <p className="text-sm font-mono-alt">{formatPrice(o.total_inr, currency)}</p>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </main>
  );
}
